import { createFileRoute } from "@tanstack/react-router";

import type { InvitationType } from "~/features/friends/components/AddFriendsView/addFriendsViewTypes.ts";
import AddFriendsPage from "~/pages/friends/AddFriendsPage.tsx";

type AddFriendsSearchParams = {
    type?: InvitationType;
    playerId?: string;
};

export const Route = createFileRoute("/_auth/friends/add")({
    validateSearch: (search: Record<string, unknown>): AddFriendsSearchParams => {
        return {
            type: typeof search.type === "string" ? (search.type as InvitationType) : undefined,
            playerId: typeof search.playerId === "string" ? search.playerId : undefined,
        };
    },
    component: AddFriendsPage,
});
